"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import CommonImage from "@/components/common/image/CommonImage";
import HomePageService from "@/services/api/HomeService";
import { usePublicFetch } from "@/hook/usePublicFetch";

export default function ServiceSection({services}) {

  return (
    <section className="our-service_section section_padding">
      <div className="container">
        <div className="our-service-wrap grid grid-cols-12 items-center gap-6">
          {/* Left Side Content */}
          <div className="md:col-span-4 col-span-12">
            <div className="section_title">
              <h2 className="title">
                <span className="w-8 h-8">
                  <CommonImage
                    src="/images/admission-icon/service-icon.png"
                    className="img-icon block [.dark_&]:hidden"
                    alt="Book Icon"
                  />
                  <CommonImage
                    src="/images/admission-icon-dark/d-service-icon.png"
                    className="img-icon hidden [.dark_&]:block"
                    alt="Book Icon"
                  />
                </span>
                আমাদের অন্যান্য সেবা সমূহ
              </h2>
              <p className="short-des">
                ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
                গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের
                মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
              </p>
            </div>

            <Link href="#" className="secondary-btn mt-6">
              আরো দেখুন
              <Image
                src={"/images/admission-icon/arrow-left.png"}
                alt="Arrow Right"
                className="arrow-icon"
                width={16}
                height={16}
              />
            </Link>
          </div>

          {/* Right Side Content (Dynamic services) */}
          <div className="md:col-span-8 col-span-12">
            <div className="service-content-card">
              {services?.map((service) => (
                <div className="service-item" key={service.id}>
                  <div className="empty">
                    <div className="icon-wrap">
                      <CommonImage
                        src={service.icon_url}
                        className="img-icon"
                        alt={service.title}
                      />
                    </div>
                  </div>
                  <div className="content-wrap">
                    <h2 className="heading">{service.title}</h2>
                    <p className="short-des">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
